import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../../core/interfaces'
import { getOpportunityEvents } from '../../opportunities'

export default function useOpportunityEvents(query: PaginatedRequest<any>) {
  const { data, error, isLoading } = useQuery(
    ['opportunityEvents', query],
    () => getOpportunityEvents(query)
  )
  return { data, error, isLoading }
}
